import React from "react";
import ProjectItem from "./ProjectItem";
import "./Main.css";
import { useNavigate } from "react-router-dom";
import { liveProducts } from "../../PlatformPage/platformContent";

const ProjectSection = () => {
  const navigate = useNavigate();

  const productLink = (slug) => {
    const product = liveProducts.find((item) => item.slug === slug);
    return product?.caseStudyPath || `/platform#${slug}`;
  };

  return (
    <div className="project-section">
      <div className="project-section-header">
        <h1>Software</h1>
        <h1>we build</h1>
      </div>
      <div className="projects">
        <ProjectItem
          id="jazzy"
          title="Jazzy's Burger"
          description="Restaurant ordering"
          display="ltr"
          onClick={() => navigate(productLink("jazzys-burger"))}
        />
        <ProjectItem
          id="ead"
          title="Eve After Dark"
          description="Cloud kitchen ops"
          display="rtl"
          onClick={() => navigate(productLink("eve-after-dark"))}
        />
        <ProjectItem
          id="yaaaga"
          title="Yaaaga!"
          description="Ecommerce & lifestyle"
          display="ltr"
          onClick={() => navigate("/caseStudy/yaaaga")}
        />
        <ProjectItem
          id="lynk"
          title="Lynk"
          description="Social media"
          display="rtl"
          onClick={() => navigate("/caseStudy/lynk")}
        />
      </div>
    </div>
  );
};

export default ProjectSection;
